import encodeQueryParams from '../route-screen-configs/utils/encodeQueryParams'
import { HOST_ADDRESS_LIST } from '../constants/apiHosts'
import { showBlockingLoader, updateEntities, appInitError } from './initActions';
import { GET_ASSOCIATED_HOTELS } from '../actionTypes/adminTypes';
import { getIndexFromCountryName } from '../utils/functions';
import Analytics from '../utils/analyticsUtil';

// TODO: reducer for  GET_ASSOCIATED_HOTELS

function getAssociatedHotels({
  hotelId,
  history,
  onError,
  onSuccess,
  clear_cache,
  allMessageFetched = false,
  language
}) {
  return (dispatch, getState) => {
    dispatch(showBlockingLoader({ status: true }));
    const qs = encodeQueryParams({
      hotelId,
      allMessageFetched,
      locale: language ? language : 'en-GB'
    });
    dispatch({
      type: GET_ASSOCIATED_HOTELS,
      hmsFetchConfig: {
        host: HOST_ADDRESS_LIST.NODE_SERVER,
        isQidInParams: false,
        path: `/user/pmAssociatedHotel?${qs}`,
        method: 'GET',
        headers: {
          clearcache: clear_cache !== undefined ? clear_cache : false
        }
      },
      onSuccess: ({ data, next, action, store }) => {
        const { hotels, categories, active_hotel_id } = data;
        if (!hotels || Object.keys(hotels).length === 0) {
          dispatch(showBlockingLoader({ status: false }));
          history.push('/404');
          return;
        }
        const active_hotel = hotels[active_hotel_id];
        if (!active_hotel) {
          dispatch(showBlockingLoader({ status: false }));
          history.push('/');
          return;
        }
        if (hotelId && +active_hotel_id !== +hotelId) {
          dispatch(showBlockingLoader({ status: false }));
          history.push('/404');
          return;
        }
        const active_country_id = active_hotel.country_id;
        const currency_symbol = active_hotel.currency_symbol || '';
        const propertyObject = {};
        propertyObject['hotel_id'] = String(active_hotel_id);
        const defaultCountryIndex = (active_country_id && getIndexFromCountryName(active_country_id)) || 0;
        propertyObject['hotel_name'] = String(active_hotel.name);
        if (active_country_id) {
          propertyObject['country_id'] = String(active_country_id);
        }
        if (active_hotel && active_hotel.oyo_id) {
          propertyObject['oyo_id'] = String(active_hotel.oyo_id);
        }
        Analytics.registerProperties(propertyObject);
        onSuccess && onSuccess({ hotel_id: active_hotel_id });
        action.payload = {
          ...action.payload,
          active_hotel_id,
          active_hotel,
          currency_symbol,
          defaultCountryIndex
        };
        next(action);
        dispatch(
          updateEntities({
            categories,
            hotels
          })
        );
        dispatch(showBlockingLoader({ status: false }));
      },
      onError: ({ error, store }) => {
        onError && onError();
        dispatch(showBlockingLoader({ status: false }));
        dispatch(appInitError(true));
      }
    });
  };
}

export default getAssociatedHotels;